import {
	Component,
	Input,
	OnInit
}                        from '@angular/core';
import { FormGroup }     from '@angular/forms';
import { BaseComponent } from '@app/core/bases/base-component/base.component';
import { IFormData }     from '@app/core/interfaces/form.interface';
import { Country }       from '@shared/components/country/models/country-country.model';
import {
	AddressFormProps,
	IAddressForm,
	IAddressFormConfig
}                        from '@shared/forms/address-form/address-form.model';
import { FormUtils }     from '@shared/forms/helpers';


@Component( {
	selector: 'app-address-form',
	templateUrl: './address-form.component.html',
	styleUrls: [ './address-form.component.scss' ]
	// intentionally no providers here - it's used as subform, don't use as standalone
} )
export class AddressFormComponent extends BaseComponent implements OnInit {

	public countryList: Country[];
	public translationPath = 'AddressForm';

	@Input() addressForm: FormGroup<IAddressForm>;
	@Input() addressFormConfig: IAddressFormConfig;
	@Input() disableControls: AddressFormProps;
	@Input() formConfigData: { [ key: string ]: IFormData };
	@Input() hideErrorDescriptions: boolean;
	@Input() hideErrors: boolean;

	constructor() {
		super();
	}


	ngOnInit() {
	}

	hasRequiredValidator( formEntityId: string ): boolean {
		return FormUtils.hasRequiredValidator( this.addressForm, formEntityId );
	}

	onCountryListEvent( countryList: Country[] ) {
		this.countryList = countryList;
	}

}
